import React from 'react';
import {GatewayGetSchema} from '../../../../api/DBSchema/Gateway';
import BaseCliScript3 from '../../AbstractObjects/GatewayPlan/InnerPages/BaseCliScript3';

const pageSchema = GatewayGetSchema.pages.cliScript3;
const pageId = pageSchema.pageId;

function PlanCliScript3({
    planObject,
    setPlanData
}) {

    let pageData = planObject[pageId];
    
    return (
        <BaseCliScript3
            pageData={pageData}
            setObjectData={setPlanData}
        />
    );
}

export default PlanCliScript3;